import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd17eb0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container modal-role p-0 overflow-hidden p-3" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-10" }
const _hoisted_4 = { class: "row mt-4" }
const _hoisted_5 = { class: "access" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "no-access" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "optional" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "row mt-4 table-responsive" }
const _hoisted_12 = { class: "table table-bordered" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { scope: "col" }, null, -1))
const _hoisted_14 = { scope: "row" }
const _hoisted_15 = { class: "cell" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isConsentPopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_AsahiTypography, {
              type: "title-1-extrabold",
              class: "text-uppercase d-none d-sm-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Role Permission Mapping')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_AsahiTypography, {
              type: "subtitle-extrabold",
              class: "text-uppercase d-sm-none"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Role Permission Mapping')), 1)
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_AsahiTypography, {
        type: "subtitle",
        color: "primary-light-green"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("permission Legends")) + ":", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_AsahiTypography, { type: "subtitle" }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("img", {
              src: _ctx.checkRingSvgIcon,
              alt: "icon"
            }, null, 8, _hoisted_6),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("permission allowed")) + ", ", 1)
          ]),
          _createElementVNode("span", _hoisted_7, [
            _createElementVNode("img", {
              src: _ctx.minusCircleSvgIcon,
              alt: "icon"
            }, null, 8, _hoisted_8),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("permission not allowed")) + ", ", 1)
          ]),
          _createElementVNode("span", _hoisted_9, [
            _createElementVNode("img", {
              src: _ctx.addSquareSvgIcon,
              alt: "icon"
            }, null, 8, _hoisted_10),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("optional permission")), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("table", _hoisted_12, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_13,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleList, (role) => {
              return (_openBlock(), _createElementBlock("th", {
                scope: "col",
                key: role,
                class: "vertical-lr rotate"
              }, [
                _createVNode(_component_AsahiTypography, { type: "subtitle-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(role)), 1)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.featureRoleMapList, (featureRoleItem) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: featureRoleItem.feature
            }, [
              _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t(`permission-${featureRoleItem.feature}`)), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(featureRoleItem.roleAccessList, (roleAccessItem) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: roleAccessItem.role
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    (roleAccessItem.access === 'yes')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.checkRingSvgIcon,
                          alt: "icon"
                        }, null, 8, _hoisted_16))
                      : _createCommentVNode("", true),
                    (roleAccessItem.access === 'no')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.minusCircleSvgIcon,
                          alt: "icon"
                        }, null, 8, _hoisted_17))
                      : _createCommentVNode("", true),
                    (roleAccessItem.access === 'optional')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 2,
                          src: _ctx.addSquareSvgIcon,
                          alt: "icon"
                        }, null, 8, _hoisted_18))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}